import { useCallback, useMemo, useState } from 'react'
import { useSlate } from 'slate-react'

import { DragNDropFileUploader, IFileSettings } from 'core-components/library/dragNDropFileUploader'
import { FILE_AVAILABLE_MIME_TYPES } from 'core-components/library/richTextEditor/constants'

import styles from './FileDialog.module.scss'

interface IProps {
  insertFiles: (files: IFileInfo[]) => void
  onClose: () => void
}

export interface IFileInfo {
  data: IFileSettings
  url: string
}

export const FileDialog = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false)
  const editor = useSlate()

  const onFileLoad = useCallback(
    (files: IFileSettings[]) => {
      if (editor.fileUploadAdapter) {
        return Promise.all(
          files.map(async (item) => {
            return await editor.fileUploadAdapter!(item)
          })
        )
      }
      return new Promise<string[]>((res) => {
        return res([])
      })
    },
    [editor.fileUploadAdapter]
  )

  const changeFileLoader = useCallback(
    async (files: IFileSettings[]) => {
      setLoading(true)
      await onFileLoad(files)
        .then((res) => {
          const filesInfo: IFileInfo[] = files.map((item, index) => ({
            data: item,
            url: res[index],
          }))
          props.insertFiles(filesInfo)
        })
        .finally(() => setLoading(false))
    },
    [props.insertFiles, onFileLoad]
  )

  const acceptedFormats = useMemo(() => {
    return FILE_AVAILABLE_MIME_TYPES.map((item) => item.value).join(', ')
  }, [])

  return (
    <div className={styles.root}>
      <DragNDropFileUploader
        changeFileLoader={changeFileLoader}
        acceptedFormats={acceptedFormats}
        urlInputVisibility={false}
        loading={loading}
      />
    </div>
  )
}
